import React, { useEffect, useState } from 'react';
import "./index.less"

const LineProgress = (props) => {
    const { percent = 0, averageNum = 0} = props;
    const [left, setLeft] = useState(0);
    const [tipLeft, setTipLeft] = useState(0);

    useEffect(() => {
        let total = 352*(percent/5) >= 352 ? 352 : 352*(percent/5) <= 0 ? 0 : 352*(percent/5);
        const interval = setInterval(() => {
            setLeft(prevProgress => {
              if (prevProgress < total) {
                return prevProgress + 10;
              } else {
                clearInterval(interval);
                return total;
              }
            });
        }, 10);
        return () => clearInterval(interval);
    },[percent])
    
    return (
        <div class="line-progress">
            <div className='line-progress-curr' style={{left: 352*(percent/5) >= 352 ? 352 - 8 : 352*(percent/5) <= 0 ? 0 : 352*(percent/5) - 8}}><span className='iconfont icon-sanjiao1'></span>{percent}</div>
            <div className="voice-item-progress-li">
                <p></p>
                <p style={{width: left}}></p>
            </div>
            <div className='line-progress-jun' style={{left: 352*(averageNum/5) >= 352 ? 352 - 8 : 352*(averageNum/5) <= 0 ? 0 : 352*(averageNum/5) - 8}}><span className='iconfont icon-sanjiao2'></span>{averageNum}</div>
        </div>
    )
};

export default LineProgress;